<template>
  <banner-component v-if="bannerData.show" :data="bannerData" @close-banner="hideBanner" />
  <div class="main-wrapper" :class="{ 'has-banner': bannerData.show }">
    <header-nav-mobile-component v-if="mobileView" />
    <header-nav-tablet-up-component v-else />
    <router-view></router-view>
  </div>
  <footer-component :mobileNavOpen="false" />
</template>

<script>
import FooterComponent from "@/components/layout/FooterComponent";
import HeaderNavMobileComponent from "@/components/layout/HeaderNavMobileComponent";
import HeaderNavTabletUpComponent from "@/components/layout/HeaderNavTabletUpComponent";
import BannerComponent from "@/components/miscellaneous/BannerComponent";
import axios from "axios";

export default {
  components: {
    FooterComponent,
    HeaderNavMobileComponent,
    HeaderNavTabletUpComponent,
    BannerComponent,
  },
  data() {
    return {
      mobileView: true,
      bannerData: {
        show: false,
        content: "",
        color: "#000000",
        background: "#FFFFFF",
      },
    };
  },
  created() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    axios
      .get("/getBanner")
      .then(({ data }) => {
        this.bannerData = data;
      });
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.mobileView = window.innerWidth < 768;
    },
    hideBanner() {
      this.bannerData.show = false;
    },
  },
};
</script>

<style lang="scss">
$mdi-font-path: "../node_modules/@mdi/font/fonts";
@import "@mdi/font/scss/materialdesignicons.scss";
* {
  box-sizing: border-box;
}
html,
body {
  font-family: $body-font-family;
  font-size: $font-size-root;
  margin: 0;
  position: relative;
}
#app {
  max-width: 1024px;
  margin: auto;
  min-height: 100vh;
  padding: calc($headerNavHeightMobile + 5px) 16px calc($footerHeightMobile);
  scroll-behavior: smooth;
  @media screen and (min-width: $tabletSize) {
    padding: calc($headerNavHeightMobile + 5px) 16px calc($footerHeightTabletUp);
  }
}
.main-wrapper {
  position: relative;

  &.has-banner {
    padding-top: 48px;
  }

  @media screen and (min-width: $tabletSize) {
    &.has-banner {
      padding-top: 52px;
    }
  }

  @media screen and (min-width: $desktopSize) {
    &.has-banner {
      padding-top: 64px;
    }
  }
}
</style>
